import React, {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';

const styles = theme => ({
    root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
    paper: {
      width: '80%',
      maxHeight: 435,
    },
  });



class ChooseArbitratorDialog extends Component {
  state = {
    //open: false
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = (value) => {
    this.props.toggleOpen();
    if(value === 'Upload_Yes'){
        this.props.setArbitrators();
    }
    //this.setState({ open: false });
  };

  render() {

    let userType = '';
    if(this.props.claimantUniqueId == this.props.uniqueId){
        userType = 'claimant';
    }else if(this.props.respondentUniqueId == this.props.uniqueId){
        userType = 'respondent';
    }
    // console.log('chooseArbitratorDialog this.props.claimantUniqueId: '+this.props.claimantUniqueId)
    // console.log('chooseArbitratorDialog this.props.respondentUniqueId: '+this.props.respondentUniqueId)
    // console.log('chooseArbitratorDialog this.props.uniqueId: '+this.props.uniqueId)
    // console.log('chooseArbitratorDialog is it respondent: '+userType)
    if (userType !== 'respondent'){
      // console.log('in ! respondent')
      return (

        <div>
          <Dialog
            disableBackdropClick
            maxWidth= 'sm'
            open={this.props.open}
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description" >
            <DialogTitle id="alert-dialog-title" disableTypography style={{fontSize:'18px'}}>{this.context.t('Confirm')}?</DialogTitle>
            
            <DialogActions>
              
              <Button disableTypography  style={{textTransform: 'none',fontSize:'18px'}} onClick={() => this.handleClose('Upload_Yes')} color="primary" autoFocus>
                {this.context.t('Yes')}
              </Button>
              
              <Button disableTypography  style={{textTransform: 'none',fontSize:'18px'}} onClick={() => this.handleClose('Upload_No')} color="primary">
              {this.context.t('No2')}
              </Button>
              
            </DialogActions>
          </Dialog>
        </div>

      );
    } else {
      console.log('in == respondent')
      return (

        <div>
          <Dialog
            disableBackdropClick
            maxWidth= 'sm'
            open={this.props.open}
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description" >
            <DialogTitle id="alert-dialog-title" disableTypography style={{fontSize:'18px'}}> 
            
            {/* {this.context.t('The Respondent proposes')} {this.props.claimantArbitratorName} {this.context.t('to be the Arbitrator, will the Respondent accept or reject this proposal?')} */}
            {this.context.t('Confirm')}?
            </DialogTitle>
            
            <DialogActions>
              
              <Button disableTypography  style={{textTransform: 'none',fontSize:'18px'}} onClick={() => this.handleClose('Upload_Yes')} color="primary" autoFocus>
                {this.context.t('Yes')}
              </Button>
              
              <Button disableTypography  style={{textTransform: 'none',fontSize:'18px'}} onClick={() => this.handleClose('Upload_No')} color="primary">
              {this.context.t('No2')}
              </Button>
              
            </DialogActions>
          </Dialog>
        </div>

      );
    }

  
}
}
ChooseArbitratorDialog.contextTypes = {
  t: PropTypes.func
}
export default withStyles(styles)(ChooseArbitratorDialog);